/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Lead_CreatedInputs */

const cs_enum_lead_created = /** @type {(inputs: Enum_Lead_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead vytvořen`)
};

const en_enum_lead_created = /** @type {(inputs: Enum_Lead_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead created`)
};

/**
* | output |
* | --- |
* | "Lead created" |
*
* @param {Enum_Lead_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_lead_created = /** @type {((inputs?: Enum_Lead_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Lead_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_lead_created(inputs)
	return cs_enum_lead_created(inputs)
});